var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeningUnavailableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6478 26.9114H33.7154L33.0305 26.251C35.9658 22.8264 37.4824 18.1543 36.6507 13.1886C35.5011 6.38836 29.826 0.9824 23.0013 0.126253C13.7305 -1.02343 5.80499 5.82575 5.14453 14.6808H10.0857C10.6728 9.49495 14.7823 5.38544 20.017 4.94514C26.2302 4.40699 31.9786 9.66618 31.9786 15.9038C31.9786 21.9947 27.0619 26.9114 20.971 26.9114C20.5552 26.9114 20.1638 26.838 19.748 26.7891V31.7303C19.748 31.7303 19.748 31.7303 19.7724 31.7548C24.1755 32.0728 28.2605 30.6051 31.3182 27.9633L31.9786 28.6482V30.5806L42.3747 40.9767C43.3776 41.9796 45.0165 41.9796 46.0194 40.9767C47.0223 39.9738 47.0223 38.3349 46.0194 37.332L35.6478 26.9114Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7018 19.989L7.51604 25.1748L2.33024 19.989C1.84101 19.4998 1.08271 19.4998 0.593483 19.989C0.104256 20.4782 0.104256 21.2365 0.593483 21.7257L5.77929 26.9116L0.593483 32.0974C0.104256 32.5866 0.104256 33.3449 0.593483 33.8341C1.08271 34.3233 1.84101 34.3233 2.33024 33.8341L7.51604 28.6483L12.7018 33.8341C13.1911 34.3233 13.9494 34.3233 14.4386 33.8341C14.9278 33.3449 14.9278 32.5866 14.4386 32.0974L9.2528 26.9116L14.4386 21.7257C14.9278 21.2365 14.9278 20.4782 14.4386 19.989C13.9494 19.5242 13.1911 19.5242 12.7018 19.989Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningUnavailableIcon);
export default __webpack_public_path__ + "static/media/openingUnavailableIcon.b2271eeaf5bf9f1b17c612b1707b7637.svg";
export { ForwardRef as ReactComponent };